// PROD
exports.firebaseConfig = {
  apiKey: 'AIzaSyDd24xwVbCf6n7gANrAVZXmnWntIQZN_pI',
  authDomain: 'mixlet.firebaseapp.com',
  databaseURL: 'https://mixlet.firebaseio.com',
  projectId: 'mixlet',
  storageBucket: 'mixlet.appspot.com',
  messagingSenderId: '52078950768',
  appId: '1:52078950768:web:4ab0a26eb5ac69d5'
};

// DAVID's DEV
// exports.firebaseConfig = {
//   apiKey: "AIzaSyAP6BhDUyqd25hG0HE2K3w-JJ5GtSasGjk",
//   authDomain: "mixlet-ca74f.firebaseapp.com",
//   databaseURL: "https://mixlet-ca74f.firebaseio.com",
//   projectId: "mixlet-ca74f",
//   storageBucket: "mixlet-ca74f.appspot.com",
//   messagingSenderId: "1079607500413",
//   appId: "1:1079607500413:web:b0b2bf05f5ec221e"
// };
